import { InfoSet } from "../InfoSets/InfoSet";
import { HashSet } from "../Utils/HashSet";
import { Device } from "../Core/Device";
import { MacAddress } from "../Core/MacAddress";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

export class BaseBridgeAddressTable extends InfoSet
{
	private _bridgeTable: HashSet<MacAddress>;

	constructor(device: Device) {
		super(device);
		this._bridgeTable = new HashSet<MacAddress>();
	}

	public Add(baseBridgeAddress:MacAddress):void {
		if (baseBridgeAddress && !baseBridgeAddress.IsNull)
			this._bridgeTable.Add(baseBridgeAddress);
	}

	public Clear():void {
		this._bridgeTable.Clear();
	}

	public get Count(): number {
		return this._bridgeTable.Count;
	}

	public Contains(baseBridgeAddress: MacAddress):boolean {
		return (this._bridgeTable.Contains(baseBridgeAddress));
	}

	public Remove(baseBridgeAddress: MacAddress):void {
		this._bridgeTable.Remove(baseBridgeAddress);
	}

	public get HasMacAddresses(): boolean {
		return true;
	}

	public get MacAddresses(): HashSet<MacAddress> {
		var macAddresses = new HashSet<MacAddress>();

		this._bridgeTable.ForEach((mac) => {
			if (mac && !mac.IsNull) {
				macAddresses.Add(mac);
			}
		});

		return (macAddresses);
	}

	public get HasMacSightings():boolean {
		return true;
	}

	public get MacSightings(): HashSet<MacAddress> {
		var macAddresses = new HashSet<MacAddress>();

		this._bridgeTable.ForEach((mac) => {
			if (mac && !mac.IsNull)
				macAddresses.Add(mac);
		});

		return (macAddresses);
	}

	public ForEach(callbackfn: (value: MacAddress, index: number, array: MacAddress[]) => void, thisArg?: any): void {
		this._bridgeTable.ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: MacAddress, index: number, array: MacAddress[]) => boolean, thisArg?: any): boolean {
		return this._bridgeTable.Some(callbackfn, thisArg);
	}

	public Write(obj: any, context: any): void {
		obj.bbridge_info = {};
		obj = obj.bbridge_info;

		obj.entries = [];
		ObjSerUtils.WriteCollection(obj.entries, this._bridgeTable, (value: MacAddress) => {
			let elem = {
				base_bridge_address_entry: {
					mac_address: ValueEncoder.EncodeMacAddress(value)
				}
			};
			return elem;
		}, context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.bbridge_info)
			throw new Error();
		obj = obj.bbridge_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((elem: any) => {
				if (!elem.base_bridge_address_entry ||
					!elem.base_bridge_address_entry.mac_address)
					throw new Error();

				let baseBridgeAddress = ValueEncoder.DecodeMacAddress(
					elem.base_bridge_address_entry.mac_address);

				this.Add(baseBridgeAddress);
			}, this);
		}
	}

}
